import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ActividadComercial } from "@/shared/types/actividad-comercial";

export async function deleteActividadComercial(id: string): Promise<ActividadComercial> {
  await sleep(1000);
  const response = await api.delete(`actividades_comerciales/${id}`);
  return response.data;
}

export function useDeleteActividadComercialMutation(id: string, mutationConfig: MutationConfig<ActividadComercial, void> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: () => deleteActividadComercial(id),
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["actividades_comerciales"] });
    },
  })
}

export interface DeleteActividadComercialMutationProps {
  id: string,
  mutationConfig?: MutationConfig<ActividadComercial, void>
  children: (mutationResult: MutationResult<ActividadComercial, void>) => ReactNode
}

export function DeleteActividadComercialMutation({
  id,
  mutationConfig,
  children
}: DeleteActividadComercialMutationProps) {
  const mutation = useDeleteActividadComercialMutation(id, mutationConfig);
  return children(mutation);
}
